(() => {
  if (window.lpStandardProductInitialized) return;
  window.lpStandardProductInitialized = true;
  document.addEventListener('change', event => {
    const input = event.target;
    if (!(input instanceof HTMLInputElement) || !input.checked) return;
    const picker = input.closest('variant-picker[data-lp-standard-options]');
    if (!picker) return;
    const scope = picker.closest('.shopify-section');
    const form = scope?.querySelector('[data-lp-standard-purchase] form');
    const data = form?.querySelector('[data-lp-checkout-variants]');
    if (!data) return;
    const options = [...picker.querySelectorAll('fieldset[data-lp-option]')].map(group => group.querySelector('input:checked')?.value);
    const variant = JSON.parse(data.textContent).find(item => item.options.every((value,index) => value === options[index]));
    const price = scope.querySelector('[data-lp-standard-price-display]');
    if (price) price.textContent = variant?.priceText || price.dataset.unavailable;
    if (picker.dataset.templateProductMatch === 'true') {
      const url = new URL(window.location.href);
      if (variant) url.searchParams.set('variant', String(variant.id));
      else url.searchParams.delete('variant');
      history.replaceState({}, '', url);
    }
    // The native variant update enables purchase only after its server response.
    form.querySelector('[ref="addToCartButton"]')?.setAttribute('disabled','');
    form.querySelector('[ref="acceleratedCheckoutButtonContainer"]')?.setAttribute('hidden','');
  });
})();
